export default __webpack_public_path__ + "static/char-v-40-26aa6ce34e02075e757e3c3710aa8d0b.png";